export default "/_next/static/88e67ce43b1beeaf128bc4eecf4cb7e6.svg";